import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import BilanForm from "./Components/Forms/BilanForm";
import BesoinVAE from "./Components/Forms/BesoinVAE";
import FormateurSatisfaction from "./Components/Forms/FormateurSatisfaction";
import FinFormation from "./Components/Forms/FinFormation";
import QuestionnaireDebut from "./Components/Forms/QuestionnaireDebut";
import Chaud from "./Components/Forms/Chaud";
import Froid from "./Components/Forms/Froid";

export default function App() {
	return (
		<BrowserRouter>
			<Routes>
				<Route path="/vae" element={<BesoinVAE />} />
				<Route path="/fs" element={<FormateurSatisfaction />} />
				<Route path="/bilan" element={<BilanForm />} />
				<Route path="/finformation" element={<FinFormation />} />
				<Route path="/debut" element={<QuestionnaireDebut />} />
				<Route path="/chaud" element={<Chaud />} />
				<Route path="/froid" element={<Froid />} />
			</Routes>
		</BrowserRouter>
	);
}
